import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SharedTooltip from "../../components/Shared/SharedTooltip";
import { formatTimestamp } from "../../components/Shared/SharedMethods";
import {
  filterCompanyInvoiceData,
  printCompanyInvoice,
  setInitialCompaniesfilter,
} from "../../store/slices/InvoicesSlice";
import CustomPagination from "../../components/Shared/CustomPagination";
import { useTranslation } from "react-i18next";
import { formatDate } from "../Transactions/TransactionsTable";
import ReceivePayment from "./ReceivePayment";
import TableLoading from "../../components/Shared/TableLoading";
import CustomTable from "../../components/Shared/CustomTable";
import supergitHIS from "../../api/supergitHIS";
import toast from "react-hot-toast";
import { HiX } from "react-icons/hi";
import CancelModal from "./CancelModal";
import { PrintIcon, SendIcon } from "../../components/Shared/TableActionIcons";
import validSupergitHIS from "../../api/validSupergitHIS";


export default function CreditInsuranceTable({
  companyInvoicesList,
  filters,
  ThirdParty,
  setFilters,
  setFilteredInvoices,
  setFiltersDetails,
  SetFiltersLoading,
  fetchListData,
  loading,
  activeTab,
  revoke = false,
}) {
  const [payload, setPayload] = useState({
    ...filters,
    page: companyInvoicesList?.page || 1,
    pageSize: companyInvoicesList?.per_page || 10,
  });
  const [zatcaLoading, setZatcaLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const { t } = useTranslation();
  const [zatcaIndex, setZatcaIndex] = useState(-1);
  const [receivePaymentDialogVisible, setReceivePaymentDialogVisible] =
    useState(false);
  const [selectedEntry, setSelectedEntry] = useState(null);

  const { isLoading } = useSelector((state) => state.invoice);
  const location = useLocation();
  const datebody = (rowData) => {
    return formatTimestamp(rowData.date);
  };

  const onPageChange = async (newPage, newRowsPerPage) => {
    let payload = {
      ...filters,
      page: newPage,
      per_page: newRowsPerPage,
    };
    fetchListData(payload);
    setPayload({ ...payload, newPage, pageSize: newRowsPerPage });
    setFilters(payload);
  };

  const handlePrintInvoice = async (data) => {
    try {
      if (ThirdParty) {
        navigate("/zatca/thirdparty/p2p-insurance-invoice", {
          state: {
            invoiceData: data,
            module: activeTab,
            path: location,
          },
        });
      } else {
        navigate("/manager/p2p-insurance-invoice", {
          state: { invoiceData: data, path: location },
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const SendToZatca = async (id) => {
    try {
      setZatcaLoading(true);
      const res = await validSupergitHIS.post(
        `zatca2/sendERPInvoicesToZatca/${id}/8ab7f7d1-8fa2-47a8-966d-97fbec298e31`,
      );
      toast.success(res.data?.message);
      console.log("id", id);
      await fetchListData(payload);
      setZatcaLoading(false);
    } catch (err) {
      setZatcaLoading(false);
      console.error(err);
    }
  };
  const templateBody = (rowData, col) => (
    <div className="flex gap-1">
      <PrintIcon
        onClick={() => {
          handlePrintInvoice(rowData);
        }}
        title={t("print")}
        className="!p-1 !text-black"
      />


      {rowData?.zatca_status === "REPORTED" ||
        rowData?.zatca_status === "CLEARED" ? null : zatcaLoading &&
          col?.rowIndex == zatcaIndex ? (
        <div className="w-4 h-4 border-2 border-black border-t-transparent rounded-full animate-spin" />
      ) : (
        <SendIcon
          onClick={() => {
            SendToZatca(rowData?.invoice_no);
          }}
          title={t("send to zatca")}
        />
      )}
    </div>
  );

  const sequenceBodyTemplate = (rowData, options) => {
    return (
      options.rowIndex +
      1 +
      (companyInvoicesList?.page - 1) * companyInvoicesList?.per_page
    );
  };
  const statusBody = (data) => {
    if (data?.status === "Paid") {
      return (
        <div className="bg-green-500 !w-[60px] p-1 text-center text-white rounded-md">
          {t("Paid")}
        </div>
      );
    } else if (data?.status === "Unpaid") {
      return (
        <div className="bg-red-500 p-1 !w-[60px] text-center text-white rounded-md">
          {t("Unpaid")}
        </div>
      );
    } else if (data?.status === "cancel") {
      return (
        <div className="bg-red-500 p-1 !w-[60px] text-center text-white rounded-md">
          {t("Cancel")}
        </div>
      );
    } else {
      return (
        <div className="bg-red-500 p-1 !w-[60px] text-center text-white rounded-md">
          {t("Unpaid")}
        </div>
      );
    }
  };
  const statusTemplate = (rowData) => {
    return (
      <div>
        {rowData?.zatca_status === "REPORTED" ? (
          <div className="bg-green-500 !w-[100px] p-1 text-center text-white rounded-md">
            {rowData?.zatca_status}
          </div>
        ) : rowData?.zatca_status === "CLEARED" ? (
          <div className="bg-blue-500 !w-[100px] p-1 text-center text-white rounded-md">
            {rowData?.zatca_status}
          </div>
        ) : (
          <div className="bg-red-500 p-1 !w-[100px] text-center text-white rounded-md">
            UNREPORTED
          </div>
        )}
      </div>
    );
  };
  const balanceBody = (data, column) => {
    let fieldName = column?.field;
    if (fieldName == "grass_amount")
      return (
        <>
          {data?.discount_amount + data?.taxable_amount} {t("SAR")}
        </>
      );
    return (
      <>
        {data[fieldName]} {t("SAR")}
      </>
    );
  };
  const columnsData = [
    {
      body: templateBody,
      header: t("actions"),
    },
    {
      body: sequenceBodyTemplate,
      header: t("no"),
      style: { width: "3rem" },
    },
    {
      field: "date",
      header: t("Order Date"),
      body: (rowData) => formatDate(rowData.created_at),
    },
    {
      field: "invoice_no",
      header: t("invoiceNumber"),
    },
    {
      field: "insurance_company.name_en",
      header: t("insuranceCompany"),
    },
    {
      field: "branch.name_en",
      header: t("branch"),
    },
    {
      field: "total_gross",
      header: t("totalGross"),
      body: balanceBody,
    },
    {
      field: "total_discount",
      header: t("totalDiscount"),
      body: balanceBody,
    },
    {
      field: "total_deduction",
      header: t("totalDeduction"),
      body: balanceBody,
    },
    {
      field: "total_net",
      header: t("totalNet"),
      body: balanceBody,
    },
    {
      field: "total_net",
      header: t("totalNet"),
      body: balanceBody,
    },
    { body: statusTemplate, header: t("Zatca Status") },
  ];

  return (
    <>
      <CustomTable
        setZatcaIndex={setZatcaIndex}
        isLoading={loading}
        loadingIcon={<TableLoading />}
        data={companyInvoicesList?.data}
        columns={columnsData}
        rows={companyInvoicesList?.per_page}
        rootyStyles="max-h-[50vh] overflow-auto"
      />
      {companyInvoicesList?.data?.length > 0 && (
        <CustomPagination
          currentPage={companyInvoicesList?.page}
          rowsPerPage={companyInvoicesList?.per_page}
          totalRecords={companyInvoicesList?.total_pages}
          totalRecord={companyInvoicesList?.total_record}
          onPageChange={onPageChange}
        />
      )}

      <ReceivePayment
        open={receivePaymentDialogVisible}
        setOpen={setReceivePaymentDialogVisible}
        selectedEntries={selectedEntry ? [selectedEntry] : []}
        filtersPayload={filters}
        setFilteredInvoices={setFilteredInvoices}
      />
      <CancelModal
        open={openCancelModal}
        fetchListData={fetchListData}
        setOpen={setOpenCancelModal}
        setSelectedEntry={setSelectedEntry}
        selectedData={selectedEntry}
      />
    </>
  );
}
